import { TAGTOOL, EVENTTYPES, genericLangues } from '@soccerwatch/common'

export const EVENTSETTINGS = TAGTOOL.EVENTSETTINGS
export const EVENTGROUPS = TAGTOOL.EVENTGROUPS
export const EVENTTYPELIST = EVENTTYPES
export const GENERICLang = genericLangues
